import { func, number, string } from 'prop-types'
import UnwrappedButton from '../Button/unwrapped.js'
import Tooltip from '../PopoverV2/Tooltip'
import { kuiperClassNames } from '../utils'

import './styles.scss'

const getPreviousButton = (onPrevious, iconHeight, iconWidth) => (
  <UnwrappedButton
    className={kuiperClassNames('navigation-controls-previous')}
    type="secondary"
    icon="chevron-lg-w"
    iconOptions={{
      height: iconHeight,
      width: iconWidth,
    }}
    onClick={onPrevious}
    trackingLabel="Navigation Controls: Previous"
  />
)

const getNextButton = (onNext, iconHeight, iconWidth) => (
  <UnwrappedButton
    className={kuiperClassNames('navigation-controls-next')}
    type="secondary"
    icon="chevron-lg-e"
    iconOptions={{
      height: iconHeight,
      width: iconWidth,
    }}
    onClick={onNext}
    trackingLabel="Navigation Controls: Next"
  />
)

const NavigationControls = ({
  iconHeight,
  iconWidth,
  nextHoverTip,
  onNext,
  onPrevious,
  onToday,
  previousHoverTip,
}) => (
  <div className={kuiperClassNames('navigation-controls')}>
    <UnwrappedButton
      className={kuiperClassNames('go-to-today')}
      onClick={onToday}
      label="Today"
      type="invisible"
    />
    <Tooltip
      className="navigation-controls-tooltip"
      content={previousHoverTip}
      popoverHandlers={{
        interactive: false,
      }}
      theme="light"
      trigger={getPreviousButton(onPrevious, iconHeight, iconWidth)}
    />
    <Tooltip
      className="navigation-controls-tooltip"
      content={nextHoverTip}
      popoverHandlers={{
        interactive: false,
      }}
      theme="light"
      trigger={getNextButton(onNext, iconHeight, iconWidth)}
    />
  </div>
)

NavigationControls.propTypes = {
  iconHeight: number,
  iconWidth: number,
  nextHoverTip: string,
  onNext: func.isRequired,
  onPrevious: func.isRequired,
  onToday: func.isRequired,
  previousHoverTip: string,
}

NavigationControls.defaultProps = {
  iconHeight: 16,
  iconWidth: 16,
  nextHoverTip: 'Next Day',
  previousHoverTip: 'Previous Day',
}

export default NavigationControls
